import React from 'react';
import { MdClose } from 'react-icons/md';
import { BannerCloseButtonProps } from '@/types/banner';

interface ExtendedBannerCloseButtonProps extends BannerCloseButtonProps {
  position?: number;
  fullScreen?: boolean;
}

const BannerCloseButton: React.FC<ExtendedBannerCloseButtonProps> = ({ 
  onClose, 
  position,
  fullScreen = false 
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // バナーのクリックイベントを防ぐ
    onClose();
  };

  // デバイス判定
  const isMobile = () => {
    if (typeof navigator !== 'undefined' && navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
      return true;
    }
    return false;
  };

  // ポジション3と6の場合は左上に配置
  const getPositionClass = () => {
    return 'tw-top-1 tw-right-1';
  };

  // サイズを調整（モバイル・フルスクリーン・ミニプレイヤーで分ける）
  const getSize = () => {
    if (fullScreen) {
      if (isMobile()) {
        return { buttonSize: 'tw-w-6 tw-h-6', iconSize: 16 };
      }
      return { buttonSize: 'tw-w-7 tw-h-7', iconSize: 18 };
    }
    return { buttonSize: 'tw-w-5 tw-h-5', iconSize: 12 };
  };

  const { buttonSize, iconSize } = getSize();
  const positionClass = getPositionClass();

  return (
    <button
      onClick={handleClick}
      className={`tw-absolute ${positionClass} tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 tw-z-50`}
      style={{
        width: fullScreen ? (isMobile() ? '20px' : '28px') : '20px',
        height: fullScreen ? (isMobile() ? '20px' : '28px') : '20px',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        borderRadius: '50%',
        border: 'none',
        outline: 'none',
        color: 'white',
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
      }}
      aria-label="バナーを閉じる"
      type="button"
    >
      <span 
        style={{ 
          fontSize: `${iconSize}px`,
          lineHeight: 1,
          fontWeight: 'bold'
        }}
      >
        ×
      </span>
    </button>
  );
};

export default BannerCloseButton; 